<template lang="pug">
  v-card.offer-list-selector(fill-height flat)
    v-flex.list( v-if="!item.subGroupList.length ")
      offer-list-item-selector(:item="item")

    v-flex.list(v-if="item.subGroupList.length > 0")
      offer-list-item-selector(v-for="(subGroupItem, idx) in item.subGroupList" :key="idx" :item="subGroupItem"
        :tagCollection="tagCollection" :itemCollection="itemCollection" :allergensList="allergensList" @update="updateData")

</template>

<script lang="ts">
import Vue from 'vue'
import MenuGroupItem from '@/model/dailymenu/MenuGroupItem'
import OfferListItemSelector from '@/components/dailymenu/detail/OfferListItemSelector.vue'
import {Component, Prop} from "vue-property-decorator";
import {FETCH_TAGS} from "@/store/action-types";
import Tag from "@/model/tennant/Tag";
import FoodItem from "@/model/food-database/FoodItem";
import Allergen from "@/model/food-database/Allergen";

@Component({
  components: {
    OfferListItemSelector
  }
})

export default class OfferListSelector extends Vue {

  private tagCollection: Tag[] | null = null

  @Prop({type: Object as () => MenuGroupItem}) item!: MenuGroupItem
  @Prop({type: [Number]}) countItems!: [Number]
  @Prop({type: Array as () => FoodItem[]}) itemCollection!: FoodItem[]
  @Prop({type: Array as () => Allergen[]}) allergensList!: Allergen[]

  updateData() {
    this.$emit('update')
  }

  async fetchData(): Promise<void> {
    const promises = [
      await this.$store.dispatch(FETCH_TAGS)
    ]

    const [
      tagCollection
    ] = await Promise.all(promises as Promise<Tag[]>[]) as [Tag[]]

    this.tagCollection = tagCollection
  }

  mounted(): void {
    this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>

.offer-list-selector
  font-size 1em
  margin 10px

.list
  flex 1

</style>
